import { render, staticRenderFns } from "./sa-organization-user-update.html?vue&type=template&id=c5b6eb2c&scoped=true&external"
import script from "./sa-organization-user-update.js?vue&type=script&lang=js&external"
export * from "./sa-organization-user-update.js?vue&type=script&lang=js&external"
import style0 from "./sa-organization-user-update.scss?vue&type=style&index=0&id=c5b6eb2c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b6eb2c",
  null
  
)

export default component.exports